import { Component } from '@angular/core';

@Component({
  selector: 'app-not-authorized',
  template: `
    <div class="not-authorized">
      <h2>Not Authorized</h2>
      <p>You do not have permission to access this page.</p>
    </div>
  `,
  styles: [`
    .not-authorized {
      text-align: center;
      margin-top: 4rem;
      color: #c00;
    }
  `]
})
export class NotAuthorizedComponent {}
